import type { Phase } from 'types';

export function getUnresolvedWorkStepsFromPhases(phases: Phase[] = []) {
  const REVISION_NEEDED_COMMENT = 'This step needs revision';

  return phases.flatMap((phase) => {
    const workSteps = phase?.workSteps ?? [];
    if (workSteps.length > 0) {
      return workSteps.filter((workstep) => {
        const isUnresolvedReview =
          workstep.review && !workstep.review.resolved?.reviewer?.date;
        const isRevisionNeeded =
          workstep.error?.comment === REVISION_NEEDED_COMMENT;
        return isUnresolvedReview || isRevisionNeeded;
      });
    }
    return [];
  });
}
